import { TaskReport } from "./TaskReport";
import { z } from "zod";

// eslint-disable-next-line @typescript-eslint/naming-convention, no-underscore-dangle, id-blacklist, id-match
export const TasksReport = z.object({
    tasks: TaskReport.array(),
});
export type TasksReport = z.infer<typeof TasksReport>;
